export default class OnlineContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Online";
    this.model = {
      userdata: {},
      playersOnline: null
    }
  }

  async show(path) {
    const app = this.app;
    const pageId = this.pageId;
    const userdata = app.userdata;
    const model = this.model;

    app.leaveNetworkGame();
    if (app.cribbage) app.cribbage.destroy();
    app.cribbage = null;

    model.userdata = userdata;

    app.populate(pageId, model);
    app.swapPage(pageId);
    

    let stats = await app.gameServer.getStats();
    if (stats) {
      model.playersOnline = stats.users;
      app.populate(pageId, model);
    }

    //pull rating now
    await this.loadUserRatings();

    //pull rating again in 4 seconds to account for delayed updates
    await this.sleep(4000);
    await this.loadUserRatings();
  }

  async loadUserRatings(){
    const app = this.app;
    const pageId = this.pageId;
    const userdata = app.userdata;
    const model = this.model;

    let oUserData = await app.gameServer.getUser(userdata.id);
    if (oUserData) {
      userdata.rank = oUserData.rank;
      userdata.rating = oUserData.rating;
      app.save();
      model.userdata = userdata;
      app.populate(pageId, model);
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}